import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GetGlobalSearch = createModule({
  base: 'GET_GLOBAL_SEARCH', apiDetails: SERVICE_ENDPOINT.GET_GLOBAL_SEARCH,
});

export { GetGlobalSearch };
